import React, { useState } from "react";
import EmissionKPI from "./EmissionKPI";
import UnitKpiSettings from "./Unit";
import GHGDbKPISettings from "./GHGDbSettingByKpi";
import KpiRequiredEvidences from "./KpiRequiredEvidences";

// ─── Sub-tab config ───────────────────────────────────────────────────────────

const KPI_SUBTABS = [
  { key: "active-kpis",         label: "Active KPIs",        icon: "chart-bar" },
  { key: "unit",                label: "Unit",               icon: "ruler" },
  { key: "ghg-databases",       label: "GHG Databases",      icon: "database" },
  { key: "required-evidences",  label: "Required Evidences", icon: "file-alt" },
];

// ─── Underline sub-nav ────────────────────────────────────────────────────────

function KpiSubNav({ activeKey, onChange }) {
  return (
    <div style={{
      display: "flex",
      gap: 0,
      borderBottom: "1.5px solid #e2e8f0",
      marginBottom: 20,
      overflowX: "auto",
      scrollbarWidth: "none",
    }}>
      {KPI_SUBTABS.map(tab => {
        const isActive = activeKey === tab.key;
        return (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 6,
              padding: "9px 18px",
              border: "none",
              borderBottom: isActive ? "2.5px solid #3f88a5" : "2.5px solid transparent",
              background: "transparent",
              color: isActive ? "#3f88a5" : "#6b7280",
              fontSize: 13,
              fontWeight: isActive ? 700 : 500,
              fontFamily: "inherit",
              cursor: "pointer",
              marginBottom: -1.5,
              transition: "color 0.15s, border-color 0.15s",
              outline: "none",
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
            onMouseEnter={e => { if (!isActive) e.currentTarget.style.color = "#1e293b"; }}
            onMouseLeave={e => { if (!isActive) e.currentTarget.style.color = "#6b7280"; }}
          >
            <i className={`fas fa-${tab.icon}`} style={{ fontSize: 12 }} aria-hidden="true" />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

// ─── Main ─────────────────────────────────────────────────────────────────────

export default function KpisGroup({ permissions, companyId }) {
  const [activeSubTab, setActiveSubTab] = useState("active-kpis");

  const renderContent = () => {
    switch (activeSubTab) {
      case "active-kpis":        return <EmissionKPI />;
      case "unit":               return <UnitKpiSettings />;
      case "ghg-databases":      return <GHGDbKPISettings />;
      case "required-evidences": return <KpiRequiredEvidences />;
      default:                   return null;
    }
  };

  return (
    <div>
      <KpiSubNav activeKey={activeSubTab} onChange={setActiveSubTab} />
      {renderContent()}
    </div>
  );
}